
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.434","height":"16.8","viewBox":"0 0 16.434 16.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.3 13.625l-2.331-3.774.027-.134.076-.055a5.256 5.256 0 002.233-4.319 5.343 5.343 0 10-5.344 5.343 5.1 5.1 0 001.218-.161l.071-.017 2.512 4.066a.904.904 0 101.538-.949zm-5.339-4.492a3.79 3.79 0 113.79-3.79 3.794 3.794 0 01-3.791 3.79zm2.491-3.79a2.49 2.49 0 11-2.491-2.49 2.494 2.494 0 012.49 2.49zm-1.841 6.6L13 14.2v.73a1.872 1.872 0 01-1.872 1.872H1.872A1.872 1.872 0 010 14.928V5.672A1.872 1.872 0 011.872 3.8h2.634a6.62 6.62 0 006.454 8.186 5.441 5.441 0 00.65-.039z","fill":"#fff"}})])
          )
        }
      }
    